import React from 'react';
import TextLarge from '../Typography/TextLarge';
import TextXXSmall from '../Typography/TextXXSmall';

function CounterBadge({ count, label }) {
  return (
    <div>
      <div className="min-w-[20px] max-w-[20px] lg:min-w-[25px] lg:max-w-[25px] h-[20px] lg:h-[32px] bg-richcarmine flex justify-center items-center p-2 border-t border-b border-fire-chalk rounded-2">
        <TextLarge text={count} className="text-xs text-white font-semibold" />
      </div>
      <TextXXSmall
        text={label}
        className="text-center text-xss text-senate font-medium"
      />
    </div>
  );
}

export default CounterBadge;
